import styled from 'styled-components';
import { Alert, AlertProps } from '@mui/material';

const Wrapper = styled(Alert)`
  width: 100%;
  height: 48px;

  &.MuiAlert-root {
    color: ${({ theme }) => theme.palette.common.black};
    border-radius: 0;
  }
`;

const PageAlert = (props: AlertProps) => <Wrapper {...props} />;

export default PageAlert;
